(window.OEFeaturedArticles = function ($, Behaviors) {
    "use strict";

    const module = {};
    const swipers = new WeakMap();

    function debounce(callback, delay) {
        let timeoutHandler = null;
        return function() {
            clearTimeout(timeoutHandler);
            timeoutHandler = setTimeout(function() {
                callback();
            }, delay);
        };
    }

    const initSwiper = module => {
        const swiperSettings = {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: module.querySelector('.bw-featured-articles-slider-pagination'),
                type: 'bullets',
                clickable: true,
            },
            loop: true,
            speed: 500,
            breakpoints: {
                768: {
                    loop: true,
                    slidesPerView: 1.8,
                    spaceBetween: 20,
                    scrollbar: {
                        dragSize: 300
                    },
                },
            },
        };

        const swiper = new Swiper(module, swiperSettings);
        swipers.set(module, swiper);
    };

    const destroySwiper = module => {
        const swiper = swipers.get(module);
        if (swiper instanceof Swiper && swiper.destroy) {
            swiper.destroy();
            swipers.delete(module);
        }
    };


    function OEFeaturedArticles() {
        const modules = document.querySelectorAll('.bw-featured-articles-slider');

        if(!modules.length) {
            return;
        }

        modules.forEach(module => {
            if(window.innerWidth < 1200) {
                if (!swipers.has(module)) {
                    initSwiper(module);
                }
            } else {
                if (swipers.has(module)) {
                    destroySwiper(module);
                }
            }
        });
    }


    module.OEFeaturedArticles = OEFeaturedArticles;

    document.addEventListener('DOMContentLoaded', () => {
        OEFeaturedArticles();
    });


    window.addEventListener('resize', debounce(function() {
        OEFeaturedArticles();
    }, 300));

    return module;

}(window.jQuery, window.Behaviors));

